import type { UseFinancingsParams } from '~/store-v2/financings/useFinancings'

export const COMBO_TYPE_FILTER = {
  ALL: 'all',
  COMBO: 'combo',
  COMBO_CONNECT: 'combo_connect',
} as const

export type ComboTypeFilter = typeof COMBO_TYPE_FILTER[keyof typeof COMBO_TYPE_FILTER]

export const COMBO_TYPE_FILTERS = Object.values(COMBO_TYPE_FILTER)

type ComboTypeParams = Pick<UseFinancingsParams, 'is_combo' | 'is_combo_connect'>

export function isComboTypeFilter(value: unknown): value is ComboTypeFilter {
  return COMBO_TYPE_FILTERS.includes(value as ComboTypeFilter)
}

// Combo Conecte wins over Combo Fácil: every Conecte project is also a combo
export function comboTypeFromParams(params: Partial<ComboTypeParams>): ComboTypeFilter {
  if (params.is_combo_connect === true)
    return COMBO_TYPE_FILTER.COMBO_CONNECT

  if (params.is_combo === 'true')
    return COMBO_TYPE_FILTER.COMBO

  return COMBO_TYPE_FILTER.ALL
}

// "All" sends no filter at all; each type sends only its own filter
export function comboTypeToParams(type: ComboTypeFilter): ComboTypeParams {
  if (type === COMBO_TYPE_FILTER.COMBO_CONNECT)
    return { is_combo: '', is_combo_connect: true }

  if (type === COMBO_TYPE_FILTER.COMBO)
    return { is_combo: 'true', is_combo_connect: undefined }

  return { is_combo: '', is_combo_connect: undefined }
}
